import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TbFileExport } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import "./Sales.css";
import "../Dashboard/Dashboard.css";
import "../Inventory/Inventory.css";
import { useNavigate } from "react-router-dom";

function createData1(  
    invoiceNo,
    dateTime,
    customerName,
    itemsSold,
    total,
    payment) {
  return {
    invoiceNo,
    dateTime,
    customerName,
    itemsSold,
    total,
    payment
  };
}

const rows1 = [
  createData1("INV-1023", "08-Sep-2025, 10:45", "Ramesh K.", "3", "₹1,250","Cash"),
 createData1("INV-1023", "08-Sep-2025, 10:45", "Ramesh K.", "3", "₹1,250","Cash"),
 createData1("INV-1023", "08-Sep-2025, 10:45", "Ramesh K.", "3", "₹1,250","Cash"),
 createData1("INV-1023", "08-Sep-2025, 10:45", "Ramesh K.", "3", "₹1,250","Cash"),
 createData1("INV-1023", "08-Sep-2025, 10:45", "Ramesh K.", "3", "₹1,250","Cash"),
];

export const Sales = () => {
    const navigate = useNavigate();
  return (
    <div className="salesContainer">
      <div className="container">
        <div className="dashboardTitleContainer">
          <div className="dasboardTitle">
            <div>Retail Sales</div>
            <div>Manage walk-in and retailer sales with billing & invoices</div>
          </div>
          <div className="d-flex gap-2">
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  className="btnDropdownMonth"
                  id="dropdown-basic"
                >
                  Today
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item>---</Dropdown.Item>
                  <Dropdown.Item>---</Dropdown.Item>
                  <Dropdown.Item>---</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="inventoryBtnReorder">
              <button onClick={()=>navigate("/state-sales-newBill")}>+ New Bill</button>
            </div>
          </div>
        </div>

        {/* cards parts  */}
        <div className="inventoryCardsGrid">
          <div className="inventoryCard">
            <div>Total Retail Sales</div>
            <div>₹48,000</div>
          </div>
          <div className="inventoryCard">
            <div>Total Bills</div>
            <div>5</div>
          </div>
          <div className="inventoryCard">
            <div>Top Selling Product</div>
            <div>Interior Enamel</div>
          </div>
        </div>

        {/* table  */}

          <div className="inventoryFilterContainer">
                  <div className="titleOrderList">Retail Sales Transactions</div>
        
                  <div className="inventoryFilters">
                    <div className="inventoryBtnExport">
                      <button>
                        Export{" "}
                        <span>
                          <TbFileExport />
                        </span>
                      </button>
                    </div>
                    <div>
                      <Dropdown>
                        <Dropdown.Toggle
                          className="btnDropdownProduct"
                          id="dropdown-basic"
                        >
                          Last 7 days
                        </Dropdown.Toggle>
        
                        <Dropdown.Menu>
                          <Dropdown.Item>---</Dropdown.Item>
                          <Dropdown.Item>---</Dropdown.Item>
                          <Dropdown.Item>---</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
        
                <div className="dashboardTableContainer">
                  <TableContainer component={Paper}>
                    <Table
                      // sx={{ minWidth: 650 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead className="dashboadTableHeader">
                        <TableRow>
                          <TableCell align="left">Invoice No.</TableCell>
                          <TableCell align="left">Date & Time</TableCell>
                          <TableCell align="left">Customer Name</TableCell>
                          <TableCell align="left">Items Sold</TableCell>
                          <TableCell align="left">Total Amount (₹)</TableCell>
                          <TableCell align="left">Payment Mode</TableCell>
                          <TableCell align="left">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows1.map((row) => (
                          <TableRow
                            key={row.name}
                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            className="dashboardTableBody"
                          >
                             <TableCell align="left">{row.invoiceNo}</TableCell>
                            <TableCell align="left">{row.dateTime}</TableCell>
                            <TableCell align="left">{row.customerName}</TableCell>
                            <TableCell align="left">{row.itemsSold}</TableCell>

                            <TableCell align="left">{row.total}</TableCell>
                             <TableCell align="left">{row.payment}</TableCell>
                           <TableCell align="left"><IoEyeOutline onClick={()=>navigate("/state-sales-view")} style={{cursor:'pointer'}}/></TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
      </div>
    </div>
  );
};
